<template>
  <div>
    <div class="container" v-if="true" ref="quan">
      <!-- <div class="dot" :class="[{onlineStyle_dot:'onlineColor', offlineStyle_dot:'offlineColor',alarmStyle_dot:'alarmColor'}]" @mouseover="markOverHandler" @mouseout="markOutHandle"></div>
            <div class="pulse" :class="[{onlineStyle_pulse:'onlineColor', offlineStyle_pulse:'offlineColor',alarmStyle_pulse:'alarmColor'}]"></div>
            <div class="pulse1" :class="[{onlineStyle_pulse1:'onlineColor', offlineStyle_pulse1:'offlineColor',alarmStyle_pulse1:'alarmColor'}]"></div> -->

      <div
        class="dot"
        :style="{
          width: typeof curStatus == 'undefined' ? '28px' : '28px',
          height: typeof curStatus == 'undefined' ? '28px' : '28px',
          backgroundSize: '100% 100%',
          background:
            curStatus == 0
              ? 'url(' + this.devLogUrl + ') no-repeat center center'
              : curStatus == 2
              ? 'url(' + this.devLogUrlAle + ') no-repeat center center'
              : curStatus == 1
              ? 'url(' + this.devLogUrlOff + ') no-repeat center center'
              : typeof curStatus == 'undefined'
              ? 'url(' +
                require('../../../../../static/img/xunjian1.png') +
                ') no-repeat center center'
              : 'transparent'
        }"
        :class="[
          {
            onlineStyle: curStatus == 1,
            offlineStyle: curStatus == 0,
            alarmStyle: curStatus == 2
          }
        ]"
        @mouseover="markOverHandler"
        @mouseout="markOutHandle"
        @click="markClickHandle"
      ></div>
      <!--            background:curStatus==0?'#d2d2d2':curStatus==1?'#56e660':curStatus==2?'red':typeof(curStatus)=='undefined'?'url(' + require('../../../../../static/img/xunjian1.png') + ') no-repeat center center':'transparent'}"-->
      <!--                            :class="[{onlineStyle:curStatus==1, offlineStyle:curStatus==0,alarmStyle:curStatus==2}]"-->
      <!--                            @mouseover="markOverHandler" @mouseout="markOutHandle" @clcik="markClickHandle"></div>-->
      <!-- 去除水波纹 -->
      <!-- <div class="people"></div> -->
      <!-- <div class="pulse" :class="[{onlineStyle:curStatus==0, offlineStyle:curStatus==1,alarmStyle:curStatus==2}]"></div> -->
      <!-- <div class="pulse1" :class="[{onlineStyle:curStatus==1, offlineStyle:curStatus==0,alarmStyle:curStatus==2}]"></div> -->
      <!-- 去除水波纹 -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "quan",
  // props:['dataList','activeIndex','item'],
  props: ["item"],
  data() {
    return {
      changeColor: true,
      curStatus: -1,
      devLogUrl: "",
      devLogUrlAle: "",
      devLogUrlOff: "",
      options: {}
    };
  },
  mounted() {
    this.curStatus = this.item.status;
    if (this.item.sceneId == 5) {
      //场站，储配站
      this.devLogUrl = require("../../../../../static/img/station_gre.png");
      this.devLogUrlAle = require("../../../../../static/img/station_red.png");
      this.devLogUrlOff = require("../../../../../static/img/station_gry.png");
    }
    if (this.item.sceneId == 6) {
      //阀门井
      this.devLogUrl = require("../../../../../static/img/valve_gre.png");
      this.devLogUrlAle = require("../../../../../static/img/valve_red.png");
      this.devLogUrlOff = require("../../../../../static/img/valve_gry.png");
    }
    if (this.item.sceneId == 7) {
      //阴极桩
      this.devLogUrl = require("../../../../../static/img/cathode_gre.png");
      this.devLogUrlAle = require("../../../../../static/img/cathode_red.png");
      this.devLogUrlOff = require("../../../../../static/img/cathode_gry.png");
    }
    if (this.item.sceneId == 3) {
      //调压箱
      this.devLogUrl = require("../../../../../static/img/tybox_gre.png");
      this.devLogUrlAle = require("../../../../../static/img/tybox_red.png");
      this.devLogUrlOff = require("../../../../../static/img/tybox_gry.png");
    }
    if (this.item.sceneId == 4) {
      //调压站
      this.devLogUrl = require("../../../../../static/img/tybox_gre.png");
      this.devLogUrlAle = require("../../../../../static/img/tybox_red.png");
      this.devLogUrlOff = require("../../../../../static/img/tybox_gry.png");
    }
    if (this.item.sceneId == 2) {
      //民品

      this.devLogUrl = require("../../../../../static/img/civil_gre.png");
      this.devLogUrlAle = require("../../../../../static/img/civil_red.png");
      this.devLogUrlOff = require("../../../../../static/img/civil_gry.png");
    }
    if (this.item.sceneId == 1) {
      //商业主机

      this.devLogUrl = require("../../../../../static/img/merchant_gre.png");
      this.devLogUrlAle = require("../../../../../static/img/merchant_red.png");
      this.devLogUrlOff = require("../../../../../static/img/merchant_gry.png");
    }
    if (this.item.sceneId == 8) {
      //泄漏监测仪

      this.devLogUrl = require("../../../../../static/img/merchant_gre.png");
      this.devLogUrlAle = require("../../../../../static/img/merchant_red.png");
      this.devLogUrlOff = require("../../../../../static/img/merchant_gry.png");
    }
    if (this.item.sceneId == 9) {
      //消杀产品

      this.devLogUrl = require("../../../../../static/img/Kill_gre.png");
      this.devLogUrlAle = require("../../../../../static/img/Kill_red.png");
      this.devLogUrlOff = require("../../../../../static/img/Kill_gry.png");
    }
    if (this.item.sceneId == 10) {
      //消杀产品

      this.devLogUrl = require("../../../../../static/img/dlbjq_gre.png");
      this.devLogUrlAle = require("../../../../../static/img/dlbjq_red.png");
      this.devLogUrlOff = require("../../../../../static/img/dltt_gry.png");
    }

    this.pitch_change();
    this.$nextTick(() => {
      this.$emit("complete", this);
    });
  },
  watch: {
    "vue.$store.state.AMapData.pitch": function() {
      this.line_pitch_change();
    }
  },
  methods: {
    pitch_change() {
      // this.$el.style.transform = `rotatex(${this.vue.$store.state.AMapData.pitch}deg)`;
      this.$emit("domChange", this);
    },
    markOverHandler() {
      // alert('鼠标移上去')
      this.$emit("markOver", this);
    },
    markOutHandle() {
      this.$emit("markOut", this);
    },
    markClickHandle() {
      this.$emit("markclick", this);
    }
  }
};
</script>
<style lang="less" scoped>
@keyframes warn {
  0% {
    transform: scale(0.3);
    -webkit-transform: scale(0.3);
    opacity: 0;
  }
  25% {
    transform: scale(0.3);
    -webkit-transform: scale(0.3);
    opacity: 0.1;
  }
  50% {
    transform: scale(0.5);
    -webkit-transform: scale(0.5);
    opacity: 0.3;
  }
  75% {
    transform: scale(0.8);
    -webkit-transform: scale(0.8);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 0;
  }
}
@keyframes warn1 {
  0% {
    transform: scale(0.3);
    -webkit-transform: scale(0.3);
    opacity: 0;
  }
  25% {
    transform: scale(0.3);
    -webkit-transform: scale(0.3);
    opacity: 0.1;
  }
  50% {
    transform: scale(0.3);
    -webkit-transform: scale(0.3);
    opacity: 0.3;
  }
  75% {
    transform: scale(0.5);
    -webkit-transform: scale(0.5);
    opacity: 0.5;
  }
  100% {
    transform: scale(0.8);
    -webkit-transform: scale(0.8);
    opacity: 0;
  }
}
.container {
  position: relative;
  /*width: 60px;*/
  /*height: 60px;*/
  /*border: 1px solid #000;*/
}
/* 保持大小不变的小圆圈  */

.onlineStyle {
  border: 2px solid rgba(26, 250, 41, 0.6);
  // box-shadow: 1px 1px 30px #56e660;
}
.offlineStyle {
  border: 2px solid #d2d2d2;
  // box-shadow: 1px 1px 30px #d2d2d2;
}
.alarmStyle {
  border: 2px solid red;
  // box-shadow: 1px 1px 30px red;
}
.people {
  background: #000;
}
.dot {
  position: absolute;
  /*width: 20px;*/
  /*height: 20px;*/
  left: 16px;

  top: 16px;
  // background: red;
  /*-webkit-border-radius: 50%;*/
  /*-moz-border-radius: 50%;*/
  border: 0px;
  /*border-radius: 50%;*/
  z-index: 2;
}
/* 产生动画（向外扩散变大）的圆圈  */
.pulse {
  position: absolute;
  width: 59px;
  height: 59px;
  /*  left: 2px;
        top: 2px;*/
  // border: 4px solid red;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  z-index: 1;
  opacity: 0;
  -webkit-animation: warn 3s linear infinite;
  -moz-animation: warn 3s linear infinite;
  animation: warn 3s linear infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  // box-shadow: 1px 1px 30px red;
}
.pulse1 {
  position: absolute;
  width: 60px;
  height: 60px;
  /* left: 2px;
        top: 2px;*/
  // border: 4px solid red;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  z-index: 1;
  opacity: 0;
  -webkit-animation: warn1 3s linear infinite;
  -webkit-animation: warn1 3s linear infinite;
  -webkit-animation: warn1 3s linear infinite;
  -moz-animation: warn1 3s infinite;
  animation: warn1 3s infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  // box-shadow: 1px 1px 30px red;
}
</style>



// WEBPACK FOOTER //
// src/page/main_content/map/baseMap/quan.vue